import {BaseApiService} from "../BaseApiService";

export class SubOrganizationApiService extends BaseApiService<object> {

    constructor() {
        super("SubOrganization");
    }

    public getByOrganization(organizationId: string){
        const url = this.prefixUrl + '/GetByOrganization?organizationId=' + organizationId;

        return this.getRequest(url);
    }

    public readBySlug(slug: string){
        const url = this.prefixUrl + '/ReadBySlug?slug=' + slug;

        return this.getRequest(url);
    }

}


// WEBPACK FOOTER //
// ./src/core/api/organization/SubOrganizationApiService.tsx